var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ta-c",staticStyle:{"padding-top":"calc((100vh - 64px) / 2 - 120px)"}},[_c('img',{staticClass:"mb20",staticStyle:{"width":"400px"},attrs:{"src":require("../../assets/logo.png")}}),_c('p',{staticClass:"ta-c fw-b fs48",staticStyle:{"color":"#858AB1"}},[_vm._v("欢迎使用上海教育科研数字平台")])])
}]

export { render, staticRenderFns }